import React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Handle, Position } from 'reactflow';

import { AppTheme } from '../../../../styles/AppTheme';
import { HANDLE_OUT } from './automationGraph';
import { AutomationNodeHeader } from './AutomationNodeHeader';
import { AutomationNodeMenu } from './AutomationNodeMenu';

const HANDLE_STYLE = {
  width: 10,
  height: 10,
  background: AppTheme.primaryColor,
  border: '2px solid #ffffff',
};

export function AutomationActionNode(props) {
  const data = props.data || {};
  const headline = data.headline || '';
  const lines = Array.isArray(data.lines) ? data.lines : [];
  return (
    <div className={css(Styles.card, props.selected && Styles.cardSelected)}>
      <Handle type='target' position={Position.Left} style={HANDLE_STYLE} />
      <AutomationNodeHeader
        icon='bolt'
        title='Action'
        menu={<AutomationNodeMenu onDelete={data.onDelete} onDuplicate={data.onDuplicate} />}
      />
      {(headline || lines.length) ? (
        <div className={css(Styles.body)}>
          {headline ? <div className={css(Styles.headline)}>{headline}</div> : null}
          {lines.map((line, index) => (
            <div key={index} className={css(Styles.line)}>{line}</div>
          ))}
        </div>
      ) : null}
      <Handle type='source' position={Position.Right} id={HANDLE_OUT} style={HANDLE_STYLE} />
    </div>
  );
}

const Styles = StyleSheet.create({
  card: {
    width: 240,
    backgroundColor: AppTheme.secondaryBg,
    border: '1px solid ' + AppTheme.borderColor,
    borderRadius: AppTheme.borderRadius,
    overflow: 'visible',
    boxSizing: 'border-box',
  },
  cardSelected: {
    borderColor: AppTheme.primaryColor,
    boxShadow: '0 0 0 3px ' + AppTheme.primaryColor + '33',
  },
  body: {
    padding: '10px 12px 12px',
    textAlign: 'left',
  },
  headline: {
    fontSize: 13,
    fontWeight: 600,
    lineHeight: '18px',
    color: '#222222',
    wordBreak: 'break-word',
  },
  line: {
    marginTop: 4,
    fontSize: 12,
    lineHeight: '16px',
    color: '#667781',
    wordBreak: 'break-word',
  },
});
